// this is an autogenerated file from DesignSystem/PaymentProvider/mutation-add-token.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_PaymentProvider(
  $type: payments_tokens_types_enum!
  $person_id: uuid!
  $reusable: Boolean!
  $provider_location_account_id: uuid!
  $response: jsonb!
) {
  payments_add_token(
    type: $type
    person_id: $person_id
    reusable: $reusable
    provider_location_account_id: $provider_location_account_id
    response: $response
  ) {
    token_id
  }
}

`